import React from "react";

const ConditionalDiv = ({ children, condition, ...props }) =>
  !!condition ? <div {...props}>{children}</div> : <>{children}</>;

export default ConditionalDiv;
